import React, { useEffect, useMemo, useState } from "react";
import { FiSearch } from "react-icons/fi";
import "../styles/styling.css";
import { renderSkeletonTable } from "../context/Customfunction";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";
import { Tooltip } from "react-bootstrap";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { AiFillCheckCircle, AiTwotoneClockCircle } from "react-icons/ai";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MdLogout } from "react-icons/md";
import { IoIosLogOut } from "react-icons/io";
import { BiTimeFive } from "react-icons/bi";

const AttendanceDashboard = () => {
  const [employeeDetail, setemployeeDetail] = useState([]);
  //console.log("employeeDetail", employeeDetail);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [cards, setCards] = useState([]);
  const id = useParams();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [date, setDate] = useState("");
  // const cards = [
  //   { label: "status", value: "present" },
  //   { label: "Check in time", value: "11:10 AM" },
  //   { label: "No. of checkouts", value: "4" },
  //   { label: "Last Checkout", value: "7:45 PM" },
  // ];

  const columns = useMemo(
    () => [
      { accessorKey: "check_in", header: "Check in" },
      { accessorKey: "check_out", header: "check out" },
      { accessorKey: "in_office", header: "In-Office" },
      { accessorKey: "out_office", header: "Out-Office" },
      {
        header: "image",
        accessorKey: "Image",
        Cell: ({ row }) => (
          // //console.log("row.original", row.original),
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/${row?.original?.image_url}`}
          />
        ),
      },
    ],
    []
  );

  const fetchDetails = async () => {
    try {
      setLoading(true);

      const queryParams = new URLSearchParams();
      if (startDate)
        queryParams.append("start_date", dayjs(startDate).format("YYYY-MM-DD"));
      if (endDate)
        queryParams.append("end_date", dayjs(endDate).format("YYYY-MM-DD"));

      const url = `${process.env.REACT_APP_BACKEND_URL}/api/employee_details/${
        id?.id
      }?${queryParams.toString()}`;

      const data = await axios.get(url);

      if (data?.data?.status === true && data.data.data.logs.length > 0) {
        const log = data.data.data.logs[0];
        //console.log("log", log);
        setemployeeDetail(log.employee_details || []);

        const availability = log.employee_availability;
        const formattedChartData = Object.entries(availability).map(
          ([key, value]) => ({ name: key, value })
        );
        setChartData(formattedChartData);

        setCards([
          {
            label: "Status",
            value: log.status,
            icon: (
              <AiFillCheckCircle style={{ fontSize: "24px", color: "black" }} />
            ),
          },
          {
            label: "Check in time",
            value: log.check_in_time,
            icon: <BiTimeFive style={{ fontSize: "24px", color: "black" }} />,
          },
          {
            label: "No. of checkouts",
            value: log.no_of_checkouts,
            icon: <MdLogout style={{ fontSize: "24px", color: "black" }} />,
          },
          {
            label: "Last Checkout",
            value: log.Last_Checkout,
            icon: <IoIosLogOut style={{ fontSize: "24px", color: "black" }} />,
          },
        ]);

        setDate(log.date);
      } else {
        setemployeeDetail([]);
        setChartData([]);
        setCards([]);
        setDate("");
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchDetails();
    }
  }, [startDate, endDate]);

  const table = useMaterialReactTable({
    columns,
    data: employeeDetail,
    enablePagination: true,
    manualPagination: true,
    enableRowSelection: false,
    enableColumnOrdering: true,
    enableTopToolbar: false,
    enableBottomToolbar: true,
    positionActionsColumn: "last",
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#F5F6F8",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
      },
    },
  });

  const COLORS = ["#42A5F5", "#FF6384", "#FFCE56"];

  return (
    <>
      {loading ? (
        <div className="fullscreen-skeleton">
          {renderSkeletonTable(columns)}
        </div>
      ) : (
        <section className="dashboard__container">
          {/* Topbar */}
          <div className="dashboard__topbar">
            <div className="dashboard__search">
              <input type="text" placeholder="Search for..." />
              <FiSearch className="dashboard__search-icon" />
            </div>
            <div className="cstDatePicker">
              <span>Date: {date}</span>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    className="dateField"
                    format="DD-MM-YYYY"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                      },
                    }}
                  />
                  <DatePicker
                    className="dateField"
                    format="DD-MM-YYYY"
                    placeholder="End Date"
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider> */}
            </div>
          </div>

          {/* Cards */}
          <div className="dashboard__cards">
            {cards.map((card, i) => (
              <div key={i} className="dashboard__card">
                <div>
                  <p>{card.label}</p>
                  <h2>{card.value}</h2>
                </div>

                <button>{card?.icon}</button>
              </div>
            ))}
          </div>

          {/* Graph Placeholder */}
          <div className="dashboard__graph-card">
            <div className="dashboard__graph-header">
              <h3>Employee Availability</h3>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: 300,
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    innerRadius={40}
                    outerRadius={100}
                    paddingAngle={2}
                    cx="50%"
                    cy="50%"
                    dataKey="value"
                  >
                    {chartData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend
                    layout="vertical"
                    align="right"
                    verticalAlign="middle"
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Tables */}
          <div className="dashboard__tables">
            <MaterialReactTable table={table} />
          </div>
        </section>
      )}
    </>
  );
};

export default AttendanceDashboard;
